import { ClientPixelHandler } from 'dabu-pixel-handler';

function initPixelHandler(ocode) {
  const types = {
    afs: 'google',
    grs: 'google',
    bing: 'bing',
  };
  const adType = types[this.dataset.adType];
  if (adType) {
    this.pixelHandler = new ClientPixelHandler(this.win, this.doc, adType, ocode, this.adContext);
  }
}

function firePageViewPixel() {
  if (this.pixelHandler) {
    this.logger.debug('Firing PageView Pixel');
    this.pixelHandler.firePageViewPixel();
  }
}

function getGoogleAdsClickTrackUrl() {
  const {
    o, ag, an, utm_source: utms, rch,
  } = this.pageParams;
  const coreProperty = {
    cd4: this.pvId,
    cd5: 'GA Event - Ad Result Click',
    cd6: this.campaignID, // not applicable for Google Ads
    cd7: `${this.dataset.dabuWidth}x${this.dataset.dabuHeight}`, // not applicable for Google Ads, ad dimention is dynamic
    cd9: this.win.location.href,
    cd10: this.sourceUrl,
    cd11: 'googleTemplates', // templateName not applicable, using google template
    cd12: '0', // genericResponse will always be false because backfill is turn off.
    cd13: this.dataset.adType,
    cd14: 'Action-Click',
    cd25: this.version,
    cd31: this.pageParams.site_id, // Taboola Site ID
    o,
    ag,
    an,
    utm_source: utms,
    googleClientId: this.adContext.pubId,
    googlePrimaryChannel: rch,
  };

  return `${this.dabuUrl}/api/v2/ta/google/click?coreProperty=${encodeURIComponent(
    JSON.stringify(coreProperty),
  )}`;
}

function getAfsConversionPixelUrls() {
  /*
   * Google AFS doesn't give us the ability to know when an ad has been clicked.
   * However we can provide any number of urls we'd like. We can map those urls.
   * note: GA/unified logging will need to be handled through the 'https://dabu.askmediagroup.com/api/v1/pixel/action' endpoint.
   *
   * single urls must be returned as strings, where multiple must be in an array.
   */
  return [
    this.getGoogleAdsClickTrackUrl(),
    `${this.win.location.origin}/web/_clk?csaClick=true&pl=%7B%7D`,
  ];
}

function fireConversionPixel(linkIdx) {
  if (this.pixelHandler) {
    this.logger.debug('Firing Conversion Pixel');
    this.pixelHandler.fireConversionPixel(linkIdx);
  }
}

function watchForCsaCookie() {
  const cookies = this.getDocumentCookies();
  if (cookies.csaClick) {
    this.doc.cookie = 'csaClick=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/;';
    this.fireConversionPixel();
  }
  // we don't want to stop polling after first click incase there's a second
  this.enqueuePollingfn(this.watchForCsaCookie);
}

function getDocumentCookies() {
  const { cookie } = this.doc;
  return cookie.split('; ').reduce((accum, current) => {
    const [name, ...value] = current.split('=');
    /* eslint-disable-next-line */
    accum[name] = value.join('=');
    return accum;
  }, {});
}

export {
  initPixelHandler,
  firePageViewPixel,
  getGoogleAdsClickTrackUrl,
  getAfsConversionPixelUrls,
  fireConversionPixel,
  watchForCsaCookie,
  getDocumentCookies,
};
